import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/outline'
import { useCoachDashboard } from '../CoachDashboardProvider'
import parse from 'html-react-parser'

const NotificationCard = ({ notification }) => {
  const { handleArchive } = useCoachDashboard()

  return (
    <div className="rounded-xl border border-silver-400 bg-white shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
      <div className="flex justify-between border-b border-silver-400 px-4 py-2 font-bold">
        {notification.sender}
        <button
          onClick={() => {
            handleArchive(notification.id)
          }}
          data-id={notification.id}
          title="Archive this notification"
          className="remove-alert flex items-center gap-1"
        >
          <XCircleIcon className="h-5 w-5 text-[#D82727]" aria-hidden="true" />
          <span className="sr-only">Archive this notification</span>
        </button>
      </div>

      <div className="min-h-36 p-4">{parse(notification.message)}</div>

      <div className="w-full p-4 text-right text-sm">
        {notification.created_at}
      </div>
    </div>
  )
}

export default NotificationCard
